import { render, staticRenderFns } from "./EditStyleBorder.vue?vue&type=template&id=4d449408&scoped=true&"
import script from "./EditStyleBorder.vue?vue&type=script&lang=js&"
export * from "./EditStyleBorder.vue?vue&type=script&lang=js&"
import style0 from "./EditStyleBorder.vue?vue&type=style&index=0&id=4d449408&lang=scss&scoped=true&"
import style1 from "./EditStyleBorder.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d449408",
  null
  
)

export default component.exports